import { FOUNDERS } from "./investData";

export const FounderSection = () => (
  <section className="border-b border-[color:var(--line)]" data-testid="invest-founders">
    <div className="mx-auto max-w-site px-6 py-24 md:px-10 md:py-32">
      <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
        <div className="md:col-span-4">
          <div className="label !text-[10px] text-[color:var(--ink-3)]">05 / Our founders</div>
        </div>
        <div className="md:col-span-8">
          <h2 className="font-display text-4xl leading-[1.02] sm:text-5xl" data-testid="invest-founders-title">
            Three roads,<br /><span className="editorial font-normal">one conclusion.</span>
          </h2>
        </div>
      </div>

      <div className="mt-14 grid grid-cols-1 border-l border-t border-[color:var(--line)] lg:grid-cols-3">
        {FOUNDERS.map((founder, index) => (
          <article key={founder.name} className="border-b border-r border-[color:var(--line)] p-7 md:p-9" data-testid={`invest-founder-${index}`}>
            <img src={founder.image} alt={founder.name} className="h-20 w-20 object-cover grayscale" />
            <div className="mt-8 label !text-[8.5px] text-[color:var(--ink-3)]">{founder.role}</div>
            <h3 className="mt-3 font-display text-3xl">{founder.name}</h3>
            <p className="mt-6 text-sm leading-relaxed text-[color:var(--ink-2)]">{founder.bio}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);